// nav-cat-grid

if (!customElements.get('nav-cat-grid-selector')) {
  class NavCatGridSelector extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.section = this.closest('.shopify-section')
      this.contentTargetSelector = this.dataset.contentTargetSelector
      this.contentTarget = this.section.querySelector(this.contentTargetSelector)
      this.addEventListener('change', this.onChange.bind(this))
      this.handleFirstQueryComplete = this.handleFirstQueryComplete.bind(this)
      document.addEventListener('ncg-first-query-complete', this.handleFirstQueryComplete)
      this.handleSecondQueryComplete = this.handleSecondQueryComplete.bind(this)
      document.addEventListener('ncg-second-query-complete', this.handleSecondQueryComplete)
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange.bind(this))
      document.removeEventListener('ncg-first-query-complete', this.handleFirstQueryComplete)
      document.removeEventListener('ncg-second-query-complete', this.handleSecondQueryComplete)
    }

    onChange(e) {
      this.contentTarget.switchMenu(e.target.value)
    }

    handleFirstQueryComplete() {
      this.classList.add('loaded')

      const urlParams = new URLSearchParams(window.location.search)
      const dep = urlParams.get('dep')
      const cat = urlParams.get('cat')

      if (!dep && !cat) return

      // Handle dep parameter
      if (dep) {
        const inputValue = `mobile-nav-${dep}`
        const input = document.querySelector(
          `nav-cat-grid-selector .nav-cat-grid__selector__item input[value="${inputValue}"]`,
        )

        if (input) {
          input.click()
        } else {
          console.error(`[NavCatGridSelector] Department not found: ${dep}`)
          if (!cat) return
        }
      }

      // Handle cat parameter
      if (cat) {
        // Wait for the dep switch to complete if both params are provided
        setTimeout(
          () => {
            const catButton = this.contentTarget.querySelector(
              `.ncg-acc__tab[data-handle="${cat}"]`,
            )

            if (catButton) {
              catButton.click()

              // Scroll to the appropriate element
              setTimeout(() => {
                const isMobile = window.innerWidth < 768
                const offset = isMobile ? -8 : -90

                let scrollTarget
                if (isMobile) {
                  // On mobile, scroll to the cat button
                  scrollTarget = catButton
                } else {
                  // On desktop, scroll to the item lists container
                  scrollTarget = this.contentTarget.querySelector('.ncg-acc__item-lists')
                }

                if (scrollTarget) {
                  const yCoordinate =
                    scrollTarget.getBoundingClientRect().top + window.pageYOffset + offset
                  window.scrollTo({ top: yCoordinate, behavior: 'smooth' })
                }
              }, 100)
            } else {
              console.error(`[NavCatGridSelector] Category not found: ${cat}`)
            }
          },
          dep ? 100 : 0,
        )
      }
    }

    async handleSecondQueryComplete() {
      // console.log('%c[SECOND QUERY COMPLETE] Fetching promos', 'color: #39ff14;')
      // const promos = await fetchPromos()
      // console.log('%c[SECOND QUERY COMPLETE] Promos fetched', 'color: #39ff14;', promos)
    }

    enableAllInputs() {
      const inputs = this.querySelectorAll('input[type="radio"]')
      inputs.forEach((input) => {
        input.disabled = false
      })
    }
  }
  customElements.define('nav-cat-grid-selector', NavCatGridSelector)
}

if (!customElements.get('nav-cat-grid')) {
  class NavCatGrid extends HTMLElement {
    abortController = null
    transformedData = null
    breakpoint = 768
    swiperInstance = null
    currentViewportType = null
    menuCache = {}
    currentMenuHandle = null
    pendingAccordionIndex = null

    constructor() {
      super()
    }

    connectedCallback() {
      // console.log(
      //   '%c[CONNECTED] Custom element connected',
      //   'color: #39ff14; font-weight: bold; font-size: 14px;',
      // )
      this.urlPrefix =
        this.dataset.country === 'us' ? '' : `/${this.dataset.locale}-${this.dataset.country}`
      this.content = this.querySelector('.js-nav-cat-grid-content')
      this.currentViewportType = this.isMobile() ? 'mobile' : 'desktop'
      this.currentMenuHandle = this.getAttribute('data-menu-handle')

      // Check for pending click from early handler
      const pendingClick = this.getAttribute('data-pending-click')
      // console.log('%c[CONNECTED] data-pending-click attribute:', 'color: #39ff14;', pendingClick)
      if (pendingClick) {
        this.pendingAccordionIndex = pendingClick
        // console.log(
        //   '%c[CONNECTED] ✓ Set pendingAccordionIndex:',
        //   'color: #39ff14; font-weight: bold;',
        //   this.pendingAccordionIndex,
        // )
        this.removeAttribute('data-pending-click')
      } else {
        // console.log('%c[CONNECTED] No pending click found', 'color: #39ff14;')
      }

      // Fast initial render - just buttons for first menu
      this.fetchInitialMenu().then(() => {
        // Load full data for all menus in background
        this.fetchAllMenus()
      })

      this.initAccordions()

      this.handleResize = debounce(() => {
        if (this.transformedData) {
          const newViewportType = this.isMobile() ? 'mobile' : 'desktop'
          // Only re-render if viewport type changed
          if (newViewportType !== this.currentViewportType) {
            this.currentViewportType = newViewportType
            this.renderContent()
          }
        }
      }, 250)
      window.addEventListener('resize', this.handleResize)
    }

    disconnectedCallback() {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize)
      }
      this.destroySwiper()
    }

    initAccordions() {
      this.addEventListener('click', (e) => {
        const tab = e.target.closest('.ncg-acc__tab')
        if (!tab) return

        if (tab.classList.contains('ncg-acc-non-active')) return

        const index = tab.getAttribute('data-grid-index')
        if (!index) return

        const panel = this.querySelector(`#animated-ncg-acc-panel-${index}`)
        if (!panel) {
          // Store pending click for when panels load
          this.pendingAccordionIndex = index
          // Show loading skeleton
          this.showLoadingSkeleton(tab, index)
          return
        }

        panel.classList.toggle('ncg-acc__panel--active')
        if (panel.classList.contains('ncg-acc__panel--active')) {
          tab.classList.add('ncg-acc__tab--active')
        } else {
          tab.classList.remove('ncg-acc__tab--active')
        }

        this.setPanelHeight(index)
        this.closeOtherPanels(tab, index)
      })
    }

    showLoadingSkeleton(tab, index) {
      const isMobile = this.isMobile()
      const tileCount = isMobile ? 6 : 8

      // Remove any existing skeleton
      this.removeLoadingSkeleton()

      // Create skeleton tiles
      const skeletonTiles = Array.from({ length: tileCount })
        .map(
          () => `
        <div class="ncg-skeleton-tile">
          <div class="ncg-skeleton-tile__image"></div>
          <div class="ncg-skeleton-tile__text"></div>
        </div>
      `,
        )
        .join('')

      const skeletonHTML = `
        <div
          class="ncg-acc__skeleton"
          id="ncg-acc-skeleton-${index}"
          data-skeleton-index="${index}"
        >
          <div class="ncg-acc__skeleton-content">
            ${skeletonTiles}
          </div>
        </div>
      `

      // Add skeleton based on viewport
      if (isMobile) {
        const pairIndex = Math.floor((parseInt(index) - 1) / 2)
        const pairs = this.content.querySelectorAll('.ncg-acc__pair')
        const pair = pairs[pairIndex]
        if (pair) {
          let itemsPair = pair.querySelector('.ncg-acc__items-pair')
          if (!itemsPair) {
            itemsPair = document.createElement('div')
            itemsPair.className = 'ncg-acc__items-pair'
            pair.appendChild(itemsPair)
          }
          itemsPair.insertAdjacentHTML('beforeend', skeletonHTML)
        }
      } else {
        let itemLists = this.content.querySelector('.ncg-acc__item-lists')
        if (!itemLists) {
          itemLists = document.createElement('div')
          itemLists.className = 'ncg-acc__item-lists'
          this.content.appendChild(itemLists)
        }
        itemLists.insertAdjacentHTML('beforeend', skeletonHTML)
      }

      // Mark tab as active
      tab.classList.add('ncg-acc__tab--active')
    }

    removeLoadingSkeleton() {
      const skeleton = this.content.querySelector('.ncg-acc__skeleton')
      if (skeleton) {
        skeleton.remove()
      }
    }

    setPanelHeight(index) {
      // console.log('%c[SET PANEL HEIGHT] Called for index:', 'color: #39ff14;', index)
      const panel = this.querySelector(`#animated-ncg-acc-panel-${index}`)
      // console.log('%c[SET PANEL HEIGHT] Panel:', 'color: #39ff14;', panel)

      if (!panel) {
        // console.log('%c[SET PANEL HEIGHT] ❌ Panel not found', 'color: #39ff14; font-weight: bold;')
        return
      }

      const children = panel.children
      let panelHeight = 0

      Array.from(children).forEach((child) => {
        panelHeight += child.offsetHeight
      })

      // console.log('%c[SET PANEL HEIGHT] Calculated height:', 'color: #39ff14;', panelHeight, 'px')
      // console.log(
      //   '%c[SET PANEL HEIGHT] Panel has active class:',
      //   'color: #39ff14;',
      //   panel.classList.contains('ncg-acc__panel--active'),
      // )

      if (panel.classList.contains('ncg-acc__panel--active')) {
        panel.style.setProperty('--panel-height', `${panelHeight}px`)
        // console.log(
        //   '%c[SET PANEL HEIGHT] ✓ Set active panel height to:',
        //   'color: #39ff14; font-weight: bold;',
        //   panelHeight,
        //   'px',
        // )
        panel.querySelectorAll('a').forEach((a) => {
          a.setAttribute('tabindex', '0')
        })
      } else {
        panel.style.setProperty('--panel-height', `0px`)
        // console.log('%c[SET PANEL HEIGHT] Set inactive panel height to 0px', 'color: #39ff14;')
        panel.querySelectorAll('a').forEach((a) => {
          a.setAttribute('tabindex', '-1')
        })
      }
    }

    closeOtherPanels(currentTab, currentIndex) {
      const tabs = this.querySelectorAll('.ncg-acc__tab')
      tabs.forEach((tab) => {
        if (tab !== currentTab) {
          const index = tab.getAttribute('data-grid-index')
          const panel = this.querySelector(`#animated-ncg-acc-panel-${index}`)

          tab.classList.remove('ncg-acc__tab--active')
          if (panel) {
            panel.classList.remove('ncg-acc__panel--active')
            panel.style.setProperty('--panel-height', `0px`)
          }
        }
      })
    }

    setFirstPanelHeight() {
      const firstPanel = this.querySelector('.ncg-acc__panel')
      if (!firstPanel) return
      const firstPanelHeight = firstPanel.offsetHeight
      firstPanel.style.setProperty('--panel-height', `${firstPanelHeight}px`)
    }

    handlePendingAccordionClick() {
      // console.log('%c[PENDING CLICK] Called', 'color: #39ff14; font-weight: bold;')
      // console.log(
      //   '%c[PENDING CLICK] this.pendingAccordionIndex value:',
      //   'color: #39ff14;',
      //   this.pendingAccordionIndex,
      // )
      if (!this.pendingAccordionIndex) {
        // console.log(
        //   '%c[PENDING CLICK] ❌ No pending index (falsy value), returning',
        //   'color: #39ff14; font-weight: bold;',
        // )
        return
      }
      const index = this.pendingAccordionIndex
      // console.log(
      //   '%c[PENDING CLICK] ✓ Has pending index:',
      //   'color: #39ff14; font-weight: bold;',
      //   index,
      // )
      const tab = this.querySelector(`#animated-ncg-acc-tab-${index}`)
      const panel = this.querySelector(`#animated-ncg-acc-panel-${index}`)
      // console.log('%c[PENDING CLICK] Tab:', 'color: #39ff14;', tab)
      // console.log('%c[PENDING CLICK] Panel:', 'color: #39ff14;', panel)

      // Remove loading skeleton (may have been created by early handler)
      this.removeLoadingSkeleton()

      if (tab && panel) {
        // console.log('%c[PENDING CLICK] Tab and panel found, proceeding', 'color: #39ff14;')
        // Remove non-active class if present (from Liquid render)
        tab.classList.remove('ncg-acc-non-active')

        panel.classList.add('ncg-acc__panel--active')
        tab.classList.add('ncg-acc__tab--active')
        // console.log('%c[PENDING CLICK] About to call setPanelHeight', 'color: #39ff14;')
        this.setPanelHeight(index)
        this.closeOtherPanels(tab, index)
        // console.log('%c[PENDING CLICK] ✓ Complete', 'color: #39ff14; font-weight: bold;')

        // No scroll - user already clicked and is at the right position
      } else {
        // console.log(
        //   '%c[PENDING CLICK] ❌ Tab or panel not found',
        //   'color: #39ff14; font-weight: bold;',
        // )
      }

      this.pendingAccordionIndex = null
    }

    switchMenu(menuHandle) {
      this.currentMenuHandle = menuHandle
      this.dataset.menuHandle = menuHandle
      this.pendingAccordionIndex = null // Clear pending clicks on menu switch
      this.removeLoadingSkeleton() // Remove any loading skeleton

      if (this.menuCache[menuHandle]) {
        const cachedData = this.menuCache[menuHandle]

        // Check if we have full data with items, or just button data
        const hasFullData =
          cachedData.categories &&
          cachedData.categories.length > 0 &&
          cachedData.categories[0].items !== undefined

        if (hasFullData) {
          // Full data available - render complete content
          this.transformedData = cachedData
          this.renderContent()
          setTimeout(() => {
            this.setFirstPanelHeight()

            // Add clearance discount badges if on clearance page
            const isClearancePage = window && window.location.pathname.includes('clearance')
            if (isClearancePage) {
              this.addClearanceDiscountBadges()
            }
          }, 50)
        } else {
          // Only button data available - render just buttons
          this.renderButtons(cachedData)
        }
      } else {
        console.warn(`Menu ${menuHandle} not found in cache`)
      }

      // scroll to element
      const offset = window.innerWidth < 768 ? -89 : -102
      const yCoordinate = this.getBoundingClientRect().top + window.pageYOffset + offset
      window.scrollTo({ top: yCoordinate, behavior: 'smooth' })
    }

    async fetchInitialMenu() {
      this.classList.add('loading')

      const allMenuHandles = this.dataset.allMenuHandles.split(',').map((h) => h.trim())
      const isClearancePage = window && window.location.pathname.includes('clearance')

      const categoryFields = /* GraphQL */ `
        categoriesField: field(key: "categories") {
          references(first: 100) {
            edges {
              node {
                ... on Metaobject {
                  nameField: field(key: "category_name") {
                    value
                  }
                  portraitImageField: field(key: "portrait_image") {
                    reference {
                      ... on MediaImage {
                        alt
                        image {
                          url
                        }
                      }
                    }
                  }
                  ${
                    isClearancePage
                      ? `clearancePortraitImageField: field(key: "clearance_portrait_image") {
                    reference {
                      ... on MediaImage {
                        alt
                        image {
                          url
                        }
                      }
                    }
                  }`
                      : ''
                  }
                  subtextField: field(key: "subtext") {
                    value
                  }
                  collectionField: field(key: "collection") {
                    reference {
                      ... on Collection {
                        onlineStoreUrl
                      }
                    }
                  }
                  itemsField: field(key: "menu_items") {
                    references(first: 1) {
                      edges {
                        node {
                          ... on Metaobject {
                            ${
                              isClearancePage
                                ? `clearanceItemField: field(key: "clearance_item") {
                              references(first: 1) {
                                edges {
                                  node {
                                    ... on Product {
                                      featuredImage {
                                        url
                                      }
                                    }
                                  }
                                }
                              }
                            }`
                                : ''
                            }
                            imageField: field(key: "image_desktop") {
                              reference {
                                ... on MediaImage {
                                  image {
                                    url
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `

      const queries = allMenuHandles.map(
        (handle) => `
        ${handle.replace(/-/g, '_')}: metaobject(handle: {handle: "${handle}", type: "menu"}) {
          ${categoryFields}
        }
      `,
      )

      const query = `
        query InitialMenus @inContext(country: ${this.dataset.country.toUpperCase()}, language: ${this.dataset.locale.toUpperCase()}) {
          ${queries.join('\n')}
        }
      `

      const endpoint = '/api/2025-07/graphql.json'

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'b7cddfa2ac815edc1ce3062ba667fe38',
          },
          body: JSON.stringify({ query }),
        })

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

        const data = await response.json()

        if (data.errors) {
          console.error('GraphQL errors:', data.errors)
        } else {
          // Cache button data for all menus
          allMenuHandles.forEach((handle) => {
            const aliasKey = handle.replace(/-/g, '_')
            if (data.data[aliasKey]) {
              const buttonData = this.transformButtonData(data.data[aliasKey])
              // Store in cache with a temporary structure
              this.menuCache[handle] = { categories: buttonData.categories }
            }
          })

          // Don't render anything yet - keep Liquid content as-is
          // The second query will add panels to existing buttons
          this.classList.remove('loading')

          // Change loading indicator from hotpink to cyan
          const loadingIndicator = document.querySelector('.loading-indicator')
          if (loadingIndicator) {
            loadingIndicator.classList.remove('loading-indicator--initial')
            loadingIndicator.classList.add('loading-indicator--data')
          }

          // Enable menu selector inputs now that all menu buttons are cached
          this.enableMenuSelector()

          this.dispatchEvent(new CustomEvent('ncg-first-query-complete', { bubbles: true }))
        }
      } catch (error) {
        console.error('Error fetching initial menu:', error)
        this.classList.remove('loading')
      }
    }

    async fetchAllMenus() {
      this.abortController?.abort()
      this.abortController = new AbortController()

      // Don't show loading - buttons are already visible

      const allMenuHandles = this.dataset.allMenuHandles.split(',').map((h) => h.trim())

      const menuFields = /* GraphQL */ `
        titleField: field(key: "title") {
          value
        }
        tabTextField: field(key: "tab_text") {
          value
        }
        categoriesField: field(key: "categories") {
          references(first: 100) {
            edges {
              node {
                ... on Metaobject {
                  nameField: field(key: "category_name") {
                    value
                  }
                  portraitImageField: field(key: "portrait_image") {
                    reference {
                      ... on MediaImage {
                        alt
                        image {
                          url
                        }
                      }
                    }
                  }
                  clearancePortraitImageField: field(key: "clearance_portrait_image") {
                    reference {
                      ... on MediaImage {
                        alt
                        image {
                          url
                        }
                      }
                    }
                  }
                  subtextField: field(key: "subtext") {
                    value
                  }
                  urlField: field(key: "url") {
                    value
                  }
                  collectionField: field(key: "collection") {
                    reference {
                      ... on Collection {
                        onlineStoreUrl
                      }
                    }
                  }
                  itemsField: field(key: "menu_items") {
                    references(first: 100) {
                      edges {
                        node {
                          ... on Metaobject {
                            titleField: field(key: "title") {
                              value
                            }
                            imageField: field(key: "image_desktop") {
                              reference {
                                ... on MediaImage {
                                  image {
                                    url
                                  }
                                }
                              }
                            }
                            imageForTestingField: field(key: "image_for_testing") {
                              reference {
                                ... on MediaImage {
                                  image {
                                    url
                                  }
                                }
                              }
                            }
                            productField: field(key: "product") {
                              reference {
                                ... on Product {
                                  title
                                  availableForSale
                                  onlineStoreUrl
                                  tags
                                  priceRange {
                                    minVariantPrice {
                                      amount
                                    }
                                    maxVariantPrice {
                                      amount
                                    }
                                  }
                                  compareAtPriceRange {
                                    minVariantPrice {
                                      amount
                                    }
                                  }
                                }
                              }
                            }
                            collectionField: field(key: "collection") {
                              reference {
                                ... on Collection {
                                  onlineStoreUrl
                                  firstAvailableProduct: products(first: 1, filters: { available: true }) {
                                    edges {
                                      node {
                                        onlineStoreUrl
                                        title
                                        availableForSale
                                        onlineStoreUrl
                                        tags
                                        priceRange {
                                          minVariantPrice {
                                            amount
                                          }
                                          maxVariantPrice {
                                            amount
                                          }
                                        }
                                        compareAtPriceRange {
                                          minVariantPrice {
                                            amount
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            useCollectionUrlField: field(key: "use_collection_url") {
                              value
                            }
                            showNewArrivalBadgeField: field(key: "show_new_arrival_badge") {
                              value
                            }
                            showNewArrivalBadgeDateField: field(key: "new_arrival_badge_end_date") {
                              value
                            }
                            clearanceItemField: field(key: "clearance_item") {
                              references(first: 10) {
                                edges {
                                  node {
                                    ... on Product {
                                      onlineStoreUrl
                                      title
                                      featuredImage {
                                        url
                                      }
                                      priceRange {
                                        minVariantPrice {
                                          amount
                                        }
                                        maxVariantPrice {
                                          amount
                                        }
                                      }
                                      compareAtPriceRange {
                                        minVariantPrice {
                                          amount
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `

      const queries = allMenuHandles.map(
        (handle) => `
        ${handle.replace(/-/g, '_')}: metaobject(handle: {handle: "${handle}", type: "menu"}) {
          ${menuFields}
        }
      `,
      )

      const query = `
        query MultipleMenus @inContext(country: ${this.dataset.country.toUpperCase()}, language: ${this.dataset.locale.toUpperCase()}) {
          ${queries.join('\n')}
          }
        `

      const endpoint = '/api/2025-07/graphql.json'

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'b7cddfa2ac815edc1ce3062ba667fe38',
          },
          body: JSON.stringify({ query }),
          signal: this.abortController.signal,
        })

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

        const data = await response.json()

        if (data.errors) {
          console.error('GraphQL errors:', data.errors)
        } else {
          // Cache all menus
          allMenuHandles.forEach((handle) => {
            const aliasKey = handle.replace(/-/g, '_')
            if (data.data[aliasKey]) {
              this.menuCache[handle] = this.transformMenuData(data.data[aliasKey])
            }
          })

          // Render full content for the current menu
          if (this.menuCache[this.currentMenuHandle]) {
            this.transformedData = this.menuCache[this.currentMenuHandle]

            // Check for Liquid-rendered initial content
            const mobileContent = this.content.querySelector('.ncg-initial-content-mobile')
            const desktopContent = this.content.querySelector('.ncg-initial-content-desktop')
            const isMobileView = this.isMobile()

            // Check if we already have buttons but no panels (initial render case)
            const existingButtons = this.content.querySelector('.ncg-acc__tab')
            const existingPanels = this.content.querySelector('.ncg-acc__panel')

            if ((mobileContent || desktopContent) && existingButtons && !existingPanels) {
              // Remove the wrong viewport content
              if (isMobileView && desktopContent) {
                desktopContent.remove()
              } else if (!isMobileView && mobileContent) {
                mobileContent.remove()
              }

              // Unwrap the correct viewport content
              const correctContent = isMobileView ? mobileContent : desktopContent
              if (correctContent) {
                const children = Array.from(correctContent.children)
                children.forEach((child) =>
                  correctContent.parentNode.insertBefore(child, correctContent),
                )
                correctContent.remove()
              }

              // Add panels to existing buttons (prevents flash)
              if (isMobileView) {
                this.addPanelsToMobile()
                // Enable buttons by removing non-active class
                const nonActiveButtons = this.content.querySelectorAll(
                  '.ncg-acc__tab.ncg-acc-non-active',
                )
                nonActiveButtons.forEach((btn) => {
                  btn.classList.remove('ncg-acc-non-active')
                })
              } else {
                this.addPanelsToDesktop()
                // Enable buttons by removing non-active class
                const nonActiveButtons = this.content.querySelectorAll(
                  '.ncg-acc__tab.ncg-acc-non-active',
                )
                nonActiveButtons.forEach((btn) => {
                  btn.classList.remove('ncg-acc-non-active')
                })
                // Initialize swiper for desktop if not already initialized
                if (!this.swiperInstance) {
                  this.initSwiper()
                }
              }
            } else {
              // Full render needed (menu switch or no content yet)
              this.renderContent()
            }

            setTimeout(() => {
              // console.log(
              //   '%c[QUERY COMPLETE] setTimeout fired, panels should be in DOM',
              //   'color: #39ff14; font-weight: bold;',
              // )

              // Check for pending click one more time in case it was set after connectedCallback
              const pendingClick = this.getAttribute('data-pending-click')
              // console.log(
              //   '%c[QUERY COMPLETE] Checking data-pending-click again:',
              //   'color: #39ff14;',
              //   pendingClick,
              // )
              if (pendingClick && !this.pendingAccordionIndex) {
                // console.log(
                //   '%c[QUERY COMPLETE] ✓ Found late pending click, setting it now:',
                //   'color: #39ff14; font-weight: bold;',
                //   pendingClick,
                // )
                this.pendingAccordionIndex = pendingClick
                this.removeAttribute('data-pending-click')
              }

              this.setFirstPanelHeight()
              // console.log(
              //   '%c[QUERY COMPLETE] About to call handlePendingAccordionClick',
              //   'color: #39ff14; font-weight: bold;',
              // )
              this.handlePendingAccordionClick()

              // Change loading indicator from cyan to black
              const loadingIndicator = document.querySelector('.loading-indicator')
              if (loadingIndicator) {
                loadingIndicator.classList.remove('loading-indicator--data')
                loadingIndicator.classList.add('loading-indicator--loaded')
              }
              // console.log('%c[QUERY COMPLETE] ✓ All done', 'color: #39ff14; font-weight: bold;')
            }, 50)
          }

          // Add clearance discount badges if on clearance page
          const isClearancePage = window && window.location.pathname.includes('clearance')
          if (isClearancePage) {
            this.addClearanceDiscountBadges()
          }

          // Dispatch event that second query is complete
          this.dispatchEvent(new CustomEvent('ncg-second-query-complete', { bubbles: true }))
        }
      } catch (error) {
        console.error('Error fetching all menus:', error)
      }
    }

    addClearanceDiscountBadges() {
      if (!this.transformedData || !this.transformedData.categories) return

      this.transformedData.categories.forEach((category, index) => {
        const categoryIndex = index + 1
        const button = this.querySelector(`#animated-ncg-acc-tab-${categoryIndex}`)
        if (!button) return

        // Find the highest discount percentage in this category
        let maxDiscount = 0
        category.items.forEach((item) => {
          if (item.discountPercentage && item.discountPercentage > maxDiscount) {
            maxDiscount = item.discountPercentage
          }
        })

        // If we have a discount, add the badge
        if (maxDiscount > 0) {
          const imageWrapper = button.querySelector('.ncg-acc__tab__image')
          if (imageWrapper) {
            const badge = document.createElement('div')
            badge.className = 'ncg-acc__tab__badge bottom-left'
            badge.style.opacity = '0'
            badge.innerHTML = `<span>Up to ${maxDiscount}% OFF</span>`
            imageWrapper.appendChild(badge)

            // Fade in the badge
            setTimeout(() => {
              badge.style.transition = 'opacity 0.3s ease-in-out'
              badge.style.opacity = '1'
            }, 50)
          }
        }
      })
    }

    enableMenuSelector() {
      const section = this.closest('.shopify-section')
      if (!section) return

      const selector = section.querySelector('nav-cat-grid-selector')
      if (selector && typeof selector.enableAllInputs === 'function') {
        selector.enableAllInputs()
      }
    }

    transformButtonData(menuData) {
      const categories =
        menuData.categoriesField?.references?.edges?.map(({ node }) => ({
          name: node.nameField?.value || null,
          subtext: node.subtextField?.value || null,
          collectionUrl: node.collectionField?.reference?.onlineStoreUrl || null,
          clearancePortraitImage: node.clearancePortraitImageField?.reference || null,
          portraitImage: node.portraitImageField?.reference || null,
          firstItemImage:
            node.itemsField?.references?.edges?.[0]?.node?.imageField?.reference?.image?.url ||
            null,
          firstItemClearanceImage:
            node.itemsField?.references?.edges?.[0]?.node?.clearanceItemField?.references
              ?.edges?.[0]?.node?.featuredImage?.url || null,
        })) || []

      return { categories }
    }

    calculateNonClearanceProductPricing(product) {
      if (!product) return null

      const productTags = product.tags || []
      const isExcludedFromSales = productTags.includes('exclude_all_sales')
      const isClearance = productTags.includes('finalsale')
      const isWeeklyDeal = productTags.includes('weekly-deal')
      const promoTag = productTags.find((tag) => tag.includes('gifting-'))
      const promoPct = isWeeklyDeal
        ? 25
        : promoTag && promoTag !== 'gifting-assortments'
          ? parseInt(promoTag.split('gifting-')[1])
          : 25
      const price = product.priceRange?.minVariantPrice?.amount
        ? parseFloat(product.priceRange.minVariantPrice.amount)
        : null
      const compareAtPrice = product.compareAtPriceRange?.minVariantPrice?.amount
        ? parseFloat(product.compareAtPriceRange.minVariantPrice.amount)
        : null
      const promoPrice = promoPct ? price * (1 - promoPct / 100) : null
      const promoDiscountPct = promoPct
        ? Math.round(((compareAtPrice - promoPrice) / compareAtPrice) * 100)
        : null
      const clearanceDiscountPct = Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
      return {
        title: product.title,
        promoPct,
        promoPrice,
        price,
        compareAtPrice,
        clearanceDiscountPct,
        promoDiscountPct,
        isClearance,
        isExcludedFromSales,
      }
    }

    transformMenuData(menuData) {
      const categories =
        menuData.categoriesField?.references?.edges?.map(({ node }) => ({
          name: node.nameField?.value || null,
          subtext: node.subtextField?.value || null,
          collectionUrl: node.collectionField?.reference?.onlineStoreUrl || null,
          clearancePortraitImage: node.clearancePortraitImageField?.reference || null,
          portraitImage: node.portraitImageField?.reference || null,
          items:
            node.itemsField?.references?.edges
              ?.map(({ node }) => {
                const clearanceProduct = node.clearanceItemField?.references?.edges?.[0]?.node
                const price = clearanceProduct?.priceRange?.minVariantPrice?.amount
                  ? parseFloat(clearanceProduct.priceRange.minVariantPrice.amount)
                  : null
                const compareAtPrice = clearanceProduct?.compareAtPriceRange?.minVariantPrice
                  ?.amount
                  ? parseFloat(clearanceProduct.compareAtPriceRange.minVariantPrice.amount)
                  : null
                const discountPercentage =
                  price && compareAtPrice && compareAtPrice > price
                    ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
                    : null

                // Use productField if available, otherwise fallback to firstAvailableProduct
                const productData =
                  node.productField?.reference ||
                  node.collectionField?.reference?.firstAvailableProduct?.edges[0]?.node ||
                  null

                const nonClearanceProductData =
                  this.calculateNonClearanceProductPricing(productData)

                return {
                  title: node.titleField?.value || null,
                  image: node.imageField?.reference?.image?.url || null,
                  collectionUrl: node.collectionField?.reference?.onlineStoreUrl || null,
                  clearanceImage:
                    node.clearanceItemField?.references?.edges?.[0]?.node?.featuredImage?.url ||
                    null,
                  image_for_testing:
                    node.imageForTestingField?.reference?.image?.url ||
                    node.imageField?.reference?.image?.url ||
                    null,
                  productUrl: node.productField?.reference?.availableForSale
                    ? node.productField?.reference?.onlineStoreUrl
                    : null,
                  nonClearanceProductData,
                  firstAvailableProductUrl:
                    node.useCollectionUrlField?.value === 'true'
                      ? node.collectionField?.reference?.onlineStoreUrl
                      : node.collectionField?.reference?.firstAvailableProduct?.edges[0]?.node
                          ?.onlineStoreUrl || null,
                  showNewArrivalBadgeField:
                    node.showNewArrivalBadgeField?.value === 'true' ? true : false,
                  showNewArrivalBadgeDateField:
                    new Date(node.showNewArrivalBadgeDateField?.value).getTime() || 0,
                  clearanceItemUrl:
                    node.clearanceItemField?.references?.edges?.[0]?.node?.onlineStoreUrl || null,
                  discountPercentage,
                }
              })
              ?.filter((item) => item.title) || [],
        })) || []

      return { categories }
    }

    isMobile() {
      return window.innerWidth < this.breakpoint
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true)
        this.swiperInstance = null
      }
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.ncg-swiper')
      if (!swiperContainer) return

      if (typeof Swiper === 'undefined') {
        console.error('Swiper is not loaded')
        return
      }

      const swiperPrevButton = this.querySelector('.ncg-swiper-button-prev')
      const swiperNextButton = this.querySelector('.ncg-swiper-button-next')

      try {
        this.swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          centerInsufficientSlides: true,
          navigation: {
            nextEl: swiperNextButton,
            prevEl: swiperPrevButton,
          },
        })
      } catch (error) {
        console.error('Failed to initialize Swiper:', error)
      }
    }

    renderButtons(buttonData) {
      if (!buttonData) return

      const isClearancePage = window && window.location.pathname.includes('clearance')
      const isMobile = this.isMobile()
      const buttons = []

      if (buttonData.categories) {
        buttonData.categories.forEach((category, index) => {
          index = index + 1
          const {
            name,
            subtext,
            clearancePortraitImage,
            portraitImage,
            firstItemImage,
            firstItemClearanceImage,
            collectionUrl,
          } = category
          // console.log(
          //   '%c[collectionUrl - renderButtons]',
          //   'color: #39ff14; font-weight: bold;',
          //   collectionUrl,
          // )

          const imageHTML = getButtonImageHTML({
            isClearancePage,
            clearanceImage: firstItemClearanceImage,
            clearancePortraitImage,
            portraitImage,
            regularImage: firstItemImage,
          })

          const buttonHTML = `
          <div class="ncg-acc__tab__wrapper">
            <button
              data-grid-index="${index}"
              data-grid-cat="${handleize(name)}"
              data-handle="${handleize(name)}"
              class="ncg-acc__tab"
              id="animated-ncg-acc-tab-${index}"
              aria-controls="animated-ncg-acc-panel-${index}"
            >
              <div class="ncg-acc__tab__image">
                  ${imageHTML}
                  <div class="ncg-acc__icon"><svg height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-icon--chevron-down"><path d="M24 32a2 2 0 0 1-1.41-.59l-12-12a2 2 0 0 1 2.82-2.82L24 27.17l10.59-10.58a2 2 0 0 1 2.82 2.82l-12 12A2 2 0 0 1 24 32z"></path></svg></div>
                  ${!isClearancePage ? `<div class="ncg-acc__tab__badge bottom-left"><span>${this.getAttribute('data-active-promo-deal-text')}</span></div>` : ''}
              </div>
              <div class="ncg-acc__tab__content">
                <p class="ncg-acc__tab__title">${name}</p>
                ${subtext ? `<p class="ncg-acc__tab__subtitle">${subtext}</p>` : ``}
              </div>
            </button>
            <a class="ncg-acc__tab__link" href="${collectionUrl}"></a>
          </div>
          `

          buttons.push(buttonHTML)
        })
      }

      if (isMobile) {
        // Mobile: render in pairs
        let html = ``
        for (let i = 0; i < buttons.length; i += 2) {
          html += `<div class="ncg-acc__pair">`
          html += `<div class="ncg-acc__cats-pair">`
          html += buttons[i]
          if (buttons[i + 1]) html += buttons[i + 1]
          html += `</div>`
          html += `</div>`
        }
        this.content.innerHTML = html
      } else {
        // Desktop: render in swiper
        let html = `
          <div class="ncg-acc__category-buttons ncg-swiper">
            <div class="swiper-wrapper">
              ${buttons.map((btn) => `<div class="swiper-slide">${btn}</div>`).join('')}
            </div>
            <div class="ncg-swiper-button-prev"></div>
            <div class="ncg-swiper-button-next"></div>
          </div>
        `
        this.content.innerHTML = html
        this.initSwiper()
      }
    }

    addPanelsToMobile() {
      // console.log('%c[ADD PANELS MOBILE] Starting', 'color: #39ff14; font-weight: bold;')
      const transformedData = this.transformedData
      if (!transformedData) {
        // console.log(
        //   '%c[ADD PANELS MOBILE] ❌ No transformedData',
        //   'color: #39ff14; font-weight: bold;',
        // )
        return
      }

      // Remove any existing skeletons before adding panels
      this.removeLoadingSkeleton()
      // console.log('%c[ADD PANELS MOBILE] Skeleton removed', 'color: #39ff14;')

      const isClearancePage = window && window.location.pathname.includes('clearance')

      const currentTimestamp = Date.now()
      const pairs = this.content.querySelectorAll('.ncg-acc__pair')

      transformedData.categories.forEach((category, catIndex) => {
        const pairIndex = Math.floor(catIndex / 2)
        const pair = pairs[pairIndex]
        if (!pair) return

        const index = catIndex + 1
        const { items: categoryItems, name: categoryName } = category
        const categoryHandle = handleize(categoryName)

        const mobileNavImgTiles = categoryItems
          .map((item) => {
            let renderItem = true
            const clearanceItemUrl = item.clearanceItemUrl || null

            if (isClearancePage && clearanceItemUrl === null) {
              renderItem = false
            } else if (
              !isClearancePage &&
              item.productUrl === null &&
              item.firstAvailableProductUrl === null
            ) {
              renderItem = false
            }

            // console.log('item.nonClearanceProductData', item.nonClearanceProductData)

            return renderItem
              ? `<li data-style="${item.title}">
                    <a href="${isClearancePage ? clearanceItemUrl : item.productUrl || item.firstAvailableProductUrl || '#'}"
                      aria-label="${item.title}"
                      class="ncg-img-tile__anchor grid-tile__anchor"
                      data-grid-cat=""
                      data-handle="${item.productHandle}"
                      id="animated-ncg-acc-tab-${index}"
                      tabindex="-1"
                    >
                      <div class="ncg-img-tile__wrapper">
                        <div class="ncg-img-tile__img-wrapper">
                          <img src="${isClearancePage ? item.clearanceImage : item.image}&width=200" class="motion-reduce ncg-img-tile__img ${item.image_for_testing ? 'nav-menu-image-for-testing_a' : ''}" loading="lazy" height="165" width="132" alt="">
                          ${item.image_for_testing ? `<img src="${isClearancePage ? item.clearanceImage : item.image_for_testing}&width=200" class="motion-reduce ncg-img-tile__img nav-menu-image-for-testing_b" loading="lazy" height="165" width="132" alt="" style="display: none;">` : ''}
                          ${isClearancePage && item.discountPercentage ? `<div class="ncg-img-tile__badge bottom-left">Up to ${item.discountPercentage}% OFF</div>` : ''}
                        </div>
                        <div class="ncg-img-tile__text-wrapper">
                          <p class="ncg-img-tile__text">
                            ${item.title.replace(/-/g, '&#8209;')}
                          </p>
                        </div>
                        </div>
                        ${createNonClearanceProductPromoPricingHTML(item.nonClearanceProductData, item.title, categoryHandle)}

                    </a>
                    ${
                      item.showNewArrivalBadgeField &&
                      item.showNewArrivalBadgeDateField > currentTimestamp
                        ? `<div class="rebuilt-product-card__badge top-left">
                      <span>New</span>
                    </div>`
                        : ''
                    }
                  </li>`
              : ``
          })
          .join('')

        if (mobileNavImgTiles !== '') {
          const panelHTML = `
            <div
              data-grid-index="${index}"
              class="ncg-acc__panel scrollbar__thin"
              id="animated-ncg-acc-panel-${index}"
              aria-labelledby="animated-ncg-acc-tab-${index}"
              style="--panel-height: 0px;"
            >
              <div class="ncg-acc__content">
                <ul class="ncg__img-tiles">
                  ${mobileNavImgTiles}
                </ul>
              </div>
            </div>
          `

          // Check if panel already exists
          if (!pair.querySelector(`#animated-ncg-acc-panel-${index}`)) {
            let itemsPair = pair.querySelector('.ncg-acc__items-pair')
            if (!itemsPair) {
              itemsPair = document.createElement('div')
              itemsPair.className = 'ncg-acc__items-pair'
              pair.appendChild(itemsPair)
            }
            itemsPair.insertAdjacentHTML('beforeend', panelHTML)
            // console.log(
            //   '%c[ADD PANELS MOBILE] ✓ Inserted panel for index:',
            //   'color: #39ff14;',
            //   index,
            // )
          } else {
            // console.log(
            //   '%c[ADD PANELS MOBILE] Panel already exists for index:',
            //   'color: #39ff14;',
            //   index,
            // )
          }
        }
      })
      // console.log('%c[ADD PANELS MOBILE] ✓ Complete', 'color: #39ff14; font-weight: bold;')
    }

    addPanelsToDesktop() {
      // console.log('%c[ADD PANELS DESKTOP] Starting', 'color: #39ff14; font-weight: bold;')
      const transformedData = this.transformedData
      if (!transformedData) {
        // console.log(
        //   '%c[ADD PANELS DESKTOP] ❌ No transformedData',
        //   'color: #39ff14; font-weight: bold;',
        // )
        return
      }

      // Remove any existing skeletons before adding panels
      this.removeLoadingSkeleton()
      // console.log('%c[ADD PANELS DESKTOP] Skeleton removed', 'color: #39ff14;')

      const isClearancePage = window && window.location.pathname.includes('clearance')

      const currentTimestamp = Date.now()
      const panels = []

      transformedData.categories.forEach((category, index) => {
        index = index + 1
        const { items: categoryItems, name: categoryName } = category
        const categoryHandle = handleize(categoryName)

        const desktopNavImgTiles = categoryItems
          .map((item) => {
            let renderItem = true
            const clearanceItemUrl = item.clearanceItemUrl || null

            if (isClearancePage && clearanceItemUrl === null) {
              renderItem = false
            } else if (
              !isClearancePage &&
              item.productUrl === null &&
              item.firstAvailableProductUrl === null
            ) {
              renderItem = false
            }

            return renderItem
              ? `<li data-style="${item.title}">
                    <a href="${isClearancePage ? clearanceItemUrl : item.productUrl || item.firstAvailableProductUrl || '#'}"
                      aria-label="${item.title}"
                      class="ncg-img-tile__anchor grid-tile__anchor"
                      data-grid-cat=""
                      data-handle="${item.productHandle}"
                      id="animated-ncg-acc-tab-${index}"
                      tabindex="-1"
                    >
                      <div class="ncg-img-tile__wrapper">
                        <div class="ncg-img-tile__img-wrapper">
                          <img src="${isClearancePage ? item.clearanceImage : item.image}&width=400" class="motion-reduce ncg-img-tile__img ${item.image_for_testing ? 'nav-menu-image-for-testing_a' : ''}" loading="lazy" height="600" width="400" alt="">
                          ${item.image_for_testing ? `<img src="${isClearancePage ? item.clearanceImage : item.image_for_testing}&width=400" class="motion-reduce ncg-img-tile__img nav-menu-image-for-testing_b" loading="lazy" height="600" width="400" alt="" style="display: none;">` : ''}
                          ${isClearancePage && item.discountPercentage ? `<div class="ncg-img-tile__badge bottom-left">Up to ${item.discountPercentage}% OFF</div>` : ''}
                        </div>
                        <div class="ncg-img-tile__text-wrapper">
                          <p class="ncg-img-tile__text">
                            ${item.title.replace(/-/g, '&#8209;')}
                          </p>
                        </div>
                        </div>
                        ${createNonClearanceProductPromoPricingHTML(item.nonClearanceProductData, item.title, categoryHandle)}

                    </a>
                    ${
                      item.showNewArrivalBadgeField &&
                      item.showNewArrivalBadgeDateField > currentTimestamp
                        ? `<div class="rebuilt-product-card__badge top-left">
                      <span>New</span>
                    </div>`
                        : ''
                    }
                  </li>`
              : ``
          })
          .join('')

        if (desktopNavImgTiles !== '') {
          const panelHTML = `
            <div
              data-grid-index="${index}"
              class="ncg-acc__panel scrollbar__thin"
              id="animated-ncg-acc-panel-${index}"
              aria-labelledby="animated-ncg-acc-tab-${index}"
              style="--panel-height: 0px;"
            >
              <div class="ncg-acc__content">
                <ul class="ncg__img-tiles">
                  ${desktopNavImgTiles}
                </ul>
              </div>
            </div>
          `
          panels.push(panelHTML)
        }
      })

      // Check if panels container already exists
      let itemLists = this.content.querySelector('.ncg-acc__item-lists')
      if (!itemLists) {
        itemLists = document.createElement('div')
        itemLists.className = 'ncg-acc__item-lists'
        this.content.appendChild(itemLists)
      }
      itemLists.innerHTML = panels.join('')
      // console.log(
      //   '%c[ADD PANELS DESKTOP] ✓ Complete - inserted',
      //   'color: #39ff14; font-weight: bold;',
      //   panels.length,
      //   'panels',
      // )
    }

    renderContent(forceFullRender = false) {
      if (!this.transformedData) return

      const isMobile = this.isMobile()
      this.currentViewportType = isMobile ? 'mobile' : 'desktop'

      // Check if we already have buttons rendered but no panels yet (from initial load)
      const existingButtons = this.content.querySelector('.ncg-acc__tab')
      const existingPanels = this.content.querySelector('.ncg-acc__panel')

      if (!forceFullRender && existingButtons && !existingPanels && isMobile) {
        // Just add panels to existing buttons on mobile
        this.addPanelsToMobile()
      } else if (!forceFullRender && existingButtons && !existingPanels && !isMobile) {
        // Just add panels to existing buttons on desktop
        this.addPanelsToDesktop()
      } else {
        // Full render needed (viewport change, menu switch, or first full render)
        this.destroySwiper()

        if (isMobile) {
          this.renderMobileStructure()
        } else {
          this.renderDesktopStructure()
          this.initSwiper()
        }

        // Add clearance badges for full renders (like viewport changes)
        const isClearancePage = window && window.location.pathname.includes('clearance')
        if (isClearancePage) {
          setTimeout(() => {
            this.addClearanceDiscountBadges()
          }, 100)
        }
      }
    }

    renderMobileStructure() {
      const transformedData = this.transformedData
      if (!transformedData) return

      const isClearancePage = window && window.location.pathname.includes('clearance')

      const currentTimestamp = Date.now()

      const items = []

      if (transformedData.categories) {
        transformedData.categories.forEach((category, index) => {
          index = index + 1
          const {
            name,
            items: categoryItems,
            subtext,
            clearancePortraitImage,
            portraitImage,
            collectionUrl,
          } = category
          const categoryHandle = handleize(name)
          const mobileNavImgTiles = categoryItems
            .map((item) => {
              let renderItem = true
              const clearanceItemUrl = item.clearanceItemUrl || null

              if (isClearancePage && clearanceItemUrl === null) {
                renderItem = false
              } else if (
                !isClearancePage &&
                item.productUrl === null &&
                item.firstAvailableProductUrl === null
              ) {
                renderItem = false
              }

              return renderItem
                ? `<li data-style="${item.title}">
                      <a href="${isClearancePage ? clearanceItemUrl : item.productUrl || item.firstAvailableProductUrl || '#'}"
                        aria-label="${item.title}"
                        class="ncg-img-tile__anchor grid-tile__anchor"
                        data-grid-cat=""
                        data-handle="${item.productHandle}"
                        id="animated-ncg-acc-tab-${index}"
                        tabindex="-1"
                      >
                        <div class="ncg-img-tile__wrapper">
                          <div class="ncg-img-tile__img-wrapper">
                            <img src="${isClearancePage ? item.clearanceImage : item.image}&width=200" class="motion-reduce ncg-img-tile__img ${item.image_for_testing ? 'nav-menu-image-for-testing_a' : ''}" loading="lazy" height="165" width="132" alt="">
                            ${item.image_for_testing ? `<img src="${isClearancePage ? item.clearanceImage : item.image_for_testing}&width=200" class="motion-reduce ncg-img-tile__img nav-menu-image-for-testing_b" loading="lazy" height="165" width="132" alt="" style="display: none;">` : ''}
                            ${isClearancePage && item.discountPercentage ? `<div class="ncg-img-tile__badge bottom-left">Up to ${item.discountPercentage}% OFF</div>` : ''}
                          </div>
                          <div class="ncg-img-tile__text-wrapper">
                            <p class="ncg-img-tile__text">
                              ${item.title}
                            </p>
                          </div>
                          </div>
                          ${createNonClearanceProductPromoPricingHTML(item.nonClearanceProductData, item.title, categoryHandle)}

                      </a>
                      ${
                        item.showNewArrivalBadgeField &&
                        item.showNewArrivalBadgeDateField > currentTimestamp
                          ? `<div class="rebuilt-product-card__badge top-left">
                        <span>New</span>
                      </div>`
                          : ''
                      }
                    </li>`
                : ``
            })
            .join('')

          if (mobileNavImgTiles !== '') {
            const imageHTML = getButtonImageHTML({
              isClearancePage,
              clearanceImage: categoryItems[0]?.clearanceImage,
              clearancePortraitImage,
              portraitImage,
              regularImage: categoryItems[0]?.image,
            })

            const buttonHTML = `
            <div class="ncg-acc__tab__wrapper">
                <button
                  data-grid-index="${index}"
                  data-grid-cat="${handleize(name)}"
                  data-handle="${handleize(name)}"
                  class="ncg-acc__tab"
                  id="animated-ncg-acc-tab-${index}"
                  aria-controls="animated-ncg-acc-panel-${index}"
                >
                  <div class="ncg-acc__tab__image">
                      ${imageHTML}
                      <div class="ncg-acc__icon"><svg height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-icon--chevron-down"><path d="M24 32a2 2 0 0 1-1.41-.59l-12-12a2 2 0 0 1 2.82-2.82L24 27.17l10.59-10.58a2 2 0 0 1 2.82 2.82l-12 12A2 2 0 0 1 24 32z"></path></svg></div>
                      ${!isClearancePage ? `<div class="ncg-acc__tab__badge bottom-left"><span>${this.getAttribute('data-active-promo-deal-text')}</span></div>` : ''}
                  </div>
                  <div class="ncg-acc__tab__content">
                    <p class="ncg-acc__tab__title">${name}</p>
                    ${subtext ? `<p class="ncg-acc__tab__subtitle">${subtext}</p>` : ``}
                  </div>
                </button>
                <a class="ncg-acc__tab__link" href="${collectionUrl}"></a>
              </div>
              `

            const panelHTML = `
                <div
                  data-grid-index="${index}"
                  class="ncg-acc__panel scrollbar__thin"
                  id="animated-ncg-acc-panel-${index}"
                  aria-labelledby="animated-ncg-acc-tab-${index}"
                  style="--panel-height: 0px;"
                >
                  <div class="ncg-acc__content">
                    <ul class="ncg__img-tiles">
                      ${mobileNavImgTiles}
                    </ul>
                  </div>
                </div>
              `

            items.push({ button: buttonHTML, panel: panelHTML })
          }
        })
      }

      let html = ``

      for (let i = 0; i < items.length; i += 2) {
        html += `<div class="ncg-acc__pair">`

        html += `<div class="ncg-acc__cats-pair">`
        html += items[i].button
        if (items[i + 1]) html += items[i + 1].button
        html += `</div>`

        html += `<div class="ncg-acc__items-pair">`
        html += items[i].panel
        if (items[i + 1]) html += items[i + 1].panel
        html += `</div>`

        html += `</div>`
      }

      this.content.innerHTML = html
    }

    renderDesktopStructure() {
      const transformedData = this.transformedData
      if (!transformedData) return

      const isClearancePage = window && window.location.pathname.includes('clearance')

      const currentTimestamp = Date.now()

      const buttons = []
      const panels = []

      if (transformedData.categories) {
        transformedData.categories.forEach((category, index) => {
          index = index + 1
          const {
            name,
            items: categoryItems,
            subtext,
            clearancePortraitImage,
            portraitImage,
            collectionUrl,
          } = category
          // console.log(
          //   '%c[collectionUrl - renderDesktopStructure]',
          //   'color: #39ff14; font-weight: bold;',
          //   collectionUrl,
          // )
          const categoryHandle = handleize(name)
          const mobileNavImgTiles = categoryItems
            .map((item) => {
              let renderItem = true
              const clearanceItemUrl = item.clearanceItemUrl || null

              if (isClearancePage && clearanceItemUrl === null) {
                renderItem = false
              } else if (
                !isClearancePage &&
                item.productUrl === null &&
                item.firstAvailableProductUrl === null
              ) {
                renderItem = false
              }

              return renderItem
                ? `<li data-style="${item.title}">
                      <a href="${isClearancePage ? clearanceItemUrl : item.productUrl || item.firstAvailableProductUrl || '#'}"
                        aria-label="${item.title}"
                        class="ncg-img-tile__anchor grid-tile__anchor"
                        data-grid-cat=""
                        data-handle="${item.productHandle}"
                        id="animated-ncg-acc-tab-${index}"
                        tabindex="-1"
                      >
                        <div class="ncg-img-tile__wrapper">
                          <div class="ncg-img-tile__img-wrapper">
                            <img src="${isClearancePage ? item.clearanceImage : item.image}&width=400" class="motion-reduce ncg-img-tile__img ${item.image_for_testing ? 'nav-menu-image-for-testing_a' : ''}" loading="lazy" height="600" width="400" alt="">
                            ${item.image_for_testing ? `<img src="${isClearancePage ? item.clearanceImage : item.image_for_testing}&width=400" class="motion-reduce ncg-img-tile__img nav-menu-image-for-testing_b" loading="lazy" height="600" width="400" alt="" style="display: none;">` : ''}
                            ${isClearancePage && item.discountPercentage ? `<div class="ncg-img-tile__badge bottom-left">Up to ${item.discountPercentage}% OFF</div>` : ''}
                          </div>
                          <div class="ncg-img-tile__text-wrapper">
                            <p class="ncg-img-tile__text">
                              ${item.title}
                            </p>
                          </div>
                          </div>
                          ${createNonClearanceProductPromoPricingHTML(item.nonClearanceProductData, item.title, categoryHandle)}

                      </a>
                      ${
                        item.showNewArrivalBadgeField &&
                        item.showNewArrivalBadgeDateField > currentTimestamp
                          ? `<div class="rebuilt-product-card__badge top-left">
                        <span>New</span>
                      </div>`
                          : ''
                      }
                    </li>`
                : ``
            })
            .join('')

          if (mobileNavImgTiles !== '') {
            const imageHTML = getButtonImageHTML({
              isClearancePage,
              clearanceImage: categoryItems[0]?.clearanceImage,
              clearancePortraitImage,
              portraitImage,
              regularImage: categoryItems[0]?.image,
            })

            const buttonHTML = `
            <div class="ncg-acc__tab__wrapper">
                <button
                  data-grid-index="${index}"
                  data-grid-cat="${handleize(name)}"
                  data-handle="${handleize(name)}"
                  class="ncg-acc__tab"
                  id="animated-ncg-acc-tab-${index}"
                  aria-controls="animated-ncg-acc-panel-${index}"
                >
                  <div class="ncg-acc__tab__image">
                      ${imageHTML}
                      <div class="ncg-acc__icon"><svg height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-icon--chevron-down"><path d="M24 32a2 2 0 0 1-1.41-.59l-12-12a2 2 0 0 1 2.82-2.82L24 27.17l10.59-10.58a2 2 0 0 1 2.82 2.82l-12 12A2 2 0 0 1 24 32z"></path></svg></div>
                      ${!isClearancePage ? `<div class="ncg-acc__tab__badge bottom-left"><span>${this.getAttribute('data-active-promo-deal-text')}</span></div>` : ''}
                  </div>
                  <div class="ncg-acc__tab__content">
                    <p class="ncg-acc__tab__title">${name}</p>
                    ${subtext ? `<p class="ncg-acc__tab__subtitle">${subtext}</p>` : ``}
                  </div>
                </button>
                <a class="ncg-acc__tab__link" href="${collectionUrl}"></a>
              </div>
              `

            const panelHTML = `
                <div
                  data-grid-index="${index}"
                  class="ncg-acc__panel scrollbar__thin"
                  id="animated-ncg-acc-panel-${index}"
                  aria-labelledby="animated-ncg-acc-tab-${index}"
                  style="--panel-height: 0px;"
                >
                  <div class="ncg-acc__content">
                    <ul class="ncg__img-tiles">
                      ${mobileNavImgTiles}
                    </ul>
                  </div>
                </div>
              `

            buttons.push(buttonHTML)
            panels.push(panelHTML)
          }
        })
      }

      let html = `
        <div class="ncg-acc__category-buttons ncg-swiper">
          <div class="swiper-wrapper">
            ${buttons.map((btn) => `<div class="swiper-slide">${btn}</div>`).join('')}
          </div>
          <div class="ncg-swiper-button-prev"></div>
          <div class="ncg-swiper-button-next"></div>
        </div>
        <div class="ncg-acc__item-lists">
          ${panels.join('')}
        </div>
      `

      this.content.innerHTML = html
    }
  }
  customElements.define('nav-cat-grid', NavCatGrid)
}

function handleize(string) {
  return string
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')
}

function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

function getButtonImageHTML(options) {
  const { isClearancePage, clearanceImage, clearancePortraitImage, portraitImage, regularImage } =
    options

  if (isClearancePage) {
    if (clearancePortraitImage) {
      return `<img src="${clearancePortraitImage.image.url}&width=400" alt="${clearancePortraitImage.alt}" width="400" height="700" fetchpriority="high" />`
    }
    if (clearanceImage) {
      return `<img src="${clearanceImage}&width=400" alt="" width="400" height="700" fetchpriority="high" />`
    }
    if (portraitImage) {
      return `<img src="${portraitImage.image.url}&width=400" alt="${portraitImage.alt}" width="400" height="700" fetchpriority="high" />`
    }
    if (regularImage) {
      return `<img src="${regularImage}&width=400" alt="" width="400" height="700" fetchpriority="high" />`
    }
  } else {
    if (portraitImage) {
      return `<img src="${portraitImage.image.url}&width=400" alt="${portraitImage.alt}" width="400" height="700" fetchpriority="high" />`
    }
    if (regularImage) {
      return `<img src="${regularImage}&width=400" alt="" width="400" height="700" fetchpriority="high" />`
    }
  }

  return `<span></span>`
}

function createNonClearanceProductPromoPricingHTML(
  nonClearanceProductData,
  familyTitle,
  categoryHandle = '',
) {
  if (!nonClearanceProductData) {
    console.log('no nonClearanceProductData', nonClearanceProductData, familyTitle)
    return ''
  }
  if (nonClearanceProductData.isExcludedFromSales) return ''

  function abbreviateProductTitle() {
    const productTitle = nonClearanceProductData.title
    const lowerFamilyTitle = familyTitle.toLowerCase()

    // Family titles that should just use the familyTitle as-is
    const useFullFamilyTitle = ['premium leather backpack', 'wallet']

    // Check if familyTitle already includes X-Pack pattern or should use full title
    if (
      /\d+-pack/i.test(familyTitle) ||
      useFullFamilyTitle.some((term) => lowerFamilyTitle.includes(term))
    ) {
      return familyTitle
    }

    // Check for N-Pack pattern in product title (2-12)
    const packMatch = productTitle.match(/(\d+)-Pack/i)

    // Family titles that should keep their trailing 's'
    const keepTrailingS = [
      'sunglasses',
      'shorts',
      'jeans',
      'slippers',
      'pants',
      'chinos',
      'joggers',
      'slides',
      'briefs',
      'boxers',
      'socks',
    ]

    // Remove trailing 's' from familyTitle if present and not in exception list
    let baseFamilyTitle = familyTitle
    const shouldKeepTrailingS = keepTrailingS.some((term) => lowerFamilyTitle.includes(term))

    if (baseFamilyTitle.endsWith('s') && !shouldKeepTrailingS) {
      baseFamilyTitle = baseFamilyTitle.slice(0, -1)
    }

    if (packMatch) {
      const packNumber = parseInt(packMatch[1])
      if (packNumber >= 2 && packNumber <= 12) {
        return `${baseFamilyTitle} ${packNumber}&#8209;Pack`
      }
    }

    return `${baseFamilyTitle} Single`
  }

  function formatPriceWithSuperscriptCents(price) {
    const contextScript = document.querySelector('#global-context-json')
    const context = contextScript ? JSON.parse(contextScript.textContent) : null

    const moneyPrefix = context?.localization_country?.currencySymbol || '$'
    const priceStr = price.toFixed(2)
    const [dollars, cents] = priceStr.split('.')
    return `${moneyPrefix}${dollars}${cents !== '00' ? `<sup>${cents}</sup>` : ''}`
  }

  const abbreviatedTitle = abbreviateProductTitle()
  const price = nonClearanceProductData.price
  const promoPrice = nonClearanceProductData.promoPrice
  const compareAtPrice = nonClearanceProductData.compareAtPrice
  const isClearance = nonClearanceProductData.isClearance
  const promoDiscountPct = nonClearanceProductData.promoDiscountPct
  const clearanceDiscountPct = nonClearanceProductData.clearanceDiscountPct

  const clearanceDiscountPctIsMissing = !clearanceDiscountPct && clearanceDiscountPct !== 0

  if (
    !abbreviatedTitle ||
    !promoPrice ||
    !compareAtPrice ||
    !promoDiscountPct ||
    clearanceDiscountPctIsMissing
  )
    return ''

  const displayPrice = isClearance ? price : promoPrice
  const displayDiscountPct = isClearance ? clearanceDiscountPct : promoDiscountPct

  // Hide title for best-sellers category
  const hideTitle = categoryHandle === 'best-sellers' || categoryHandle === 'flash-deals'
  const titleStyle = hideTitle ? ' style="display: none;"' : ''

  return `
  <div class="ncg-img-tile__text-promo-wrapper">
    <p class="ncg-img-tile__text-promo-pct">${displayDiscountPct}% OFF</p>
    <p class="ncg-img-tile__text-promo-title"${titleStyle}>${abbreviatedTitle}</p>
    <p class="ncg-img-tile__text-promo-prices">
      <span class="ncg-img-tile__text-promo-price">${formatPriceWithSuperscriptCents(displayPrice + 0.01)}</span>
      <span class="ncg-img-tile__text-promo-compare-at-price">${formatPriceWithSuperscriptCents(compareAtPrice)}</span>
    </p>
  </div>
  `
}

async function fetchPromos() {
  const navCatGrid = document.querySelector('nav-cat-grid')
  if (!navCatGrid) return

  const query = /* GraphQL */ `
    query Promos {
      metaobjects(type: "promo", first: 100) {
        edges {
          node {
            nameField: field(key: "name") {
              value
            }
            holidayNameField: field(key: "holiday_name") {
              value
            }
            percentageDiscountField: field(key: "percentage_discount") {
              value
            }
            includedCountriesField: field(key: "included_countries") {
              value
            }
            excludedCountriesField: field(key: "excluded_countries") {
              value
            }
            startTimeField: field(key: "start_time") {
              value
            }
            endTimeField: field(key: "end_time") {
              value
            }
          }
        }
      }
    }
  `

  const endpoint = '/api/2025-07/graphql.json'

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'b7cddfa2ac815edc1ce3062ba667fe38',
      },
      body: JSON.stringify({ query }),
    })

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

    const data = await response.json()

    if (data.errors) {
      console.error('GraphQL errors:', data.errors)
      return null
    } else {
      const userCountry = navCatGrid.dataset.country.toUpperCase()
      const filteredPromos = filterPromosByCountryAndTime(data.data.metaobjects.edges, userCountry)
      navCatGrid.promos = filteredPromos
      return filteredPromos
    }
  } catch (error) {
    console.error('Error fetching promos:', error)
    return null
  }
}

function filterPromosByCountryAndTime(promoEdges, userCountry) {
  const currentTime = Date.now()

  return promoEdges
    .filter(({ node }) => {
      const includedCountries = node.includedCountriesField?.value || ''
      const excludedCountries = node.excludedCountriesField?.value || ''
      const startTime = node.startTimeField?.value || ''
      const endTime = node.endTimeField?.value || ''

      const includedList = includedCountries
        .split(',')
        .map((c) => c.trim().toUpperCase())
        .filter((c) => c)
      const excludedList = excludedCountries
        .split(',')
        .map((c) => c.trim().toUpperCase())
        .filter((c) => c)

      const countryMatch =
        (includedList.length === 0 && excludedList.length === 0) ||
        (includedList.length > 0 && includedList.includes(userCountry)) ||
        (includedList.length === 0 && !excludedList.includes(userCountry))

      if (!countryMatch) return false

      const startTimeMs = startTime ? new Date(startTime).getTime() : null
      const endTimeMs = endTime ? new Date(endTime).getTime() : null

      if (startTimeMs && currentTime < startTimeMs) return false
      if (endTimeMs && currentTime > endTimeMs) return false

      return true
    })
    .map(({ node }) => ({
      name: node.nameField?.value || '',
      holidayName: node.holidayNameField?.value || '',
      percentageDiscount: node.percentageDiscountField?.value || '',
    }))
}
